"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.EpicWalletOptionCard = EpicWalletOptionCard;
exports.HyperWalletOptionCard = HyperWalletOptionCard;

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

var _EpicWalletTermsPopup = require("./EpicWalletTermsPopup");

var _EpicWalletTermsPopup2 = _interopRequireDefault(_EpicWalletTermsPopup);

var _helpersStylesIcons = require("./helpers-styles-icons");

var _HyperWalletFormPopup = require("./HyperWalletFormPopup");

var _HyperWalletFormPopup2 = _interopRequireDefault(_HyperWalletFormPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatCurrency = function formatCurrency(value, currency) {
  var symbol = currency === "USD" ? "$" : "" + currency;
  var symbolInParans = symbol !== currency ? "(" + symbol + ")" : "";
  return [Number(value.toFixed(2).toString()), currency, symbolInParans].filter(function (i) {
    return i;
  }).join(" ");
};

function OptionCardErrorOverlay(_ref) {
  var title = _ref.title,
      description = _ref.description;

  return _react2.default.createElement(
    "div",
    { className: _helpersStylesIcons.optionCardStyles.errorRoot },
    _react2.default.createElement("div", { className: _helpersStylesIcons.optionCardStyles.errorBackdrop }),
    _react2.default.createElement(
      "div",
      { className: _helpersStylesIcons.optionCardStyles.errorContent },
      _react2.default.createElement(
        "div",
        { className: (0, _helpersStylesIcons.boxStyles)({ paddingTop: "6px" }) },
        _react2.default.createElement(_helpersStylesIcons.ErrorIconSvg, null)
      ),
      _react2.default.createElement(
        "div",
        { className: (0, _helpersStylesIcons.textStyles)({ color: _helpersStylesIcons.gray, size: "15px", height: "20px" }) },
        _react2.default.createElement(
          "p",
          { className: (0, _helpersStylesIcons.textStyles)({ color: "white", marginBottom: "8px", weight: "500" }) },
          title
        ),
        description && _react2.default.createElement(
          "p",
          null,
          description
        )
      )
    )
  );
}

function OptionCard(_ref2) {
  var _classNames;

  var title = _ref2.title,
      content = _ref2.content,
      _ref2$label = _ref2.label,
      label = _ref2$label === undefined ? "Continue" : _ref2$label,
      _ref2$onSelect = _ref2.onSelect,
      onSelect = _ref2$onSelect === undefined ? function () {} : _ref2$onSelect,
      _ref2$error = _ref2.error,
      error = _ref2$error === undefined ? null : _ref2$error;

  return _react2.default.createElement(
    "div",
    {
      className: (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, _helpersStylesIcons.optionCardStyles.root, true), (0, _defineProperty3.default)(_classNames, _helpersStylesIcons.optionCardStyles.rootWithError, !!error), _classNames)) },
    _react2.default.createElement(
      "div",
      { className: (0, _helpersStylesIcons.classes)("optionCardContent", _helpersStylesIcons.optionCardStyles.content) },
      _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "h4",
          { className: _helpersStylesIcons.optionCardStyles.title },
          title
        ),
        _react2.default.createElement(
          "div",
          {
            className: (0, _helpersStylesIcons.classes)((0, _helpersStylesIcons.boxStyles)({ marginTop: "16px" }), (0, _helpersStylesIcons.textStyles)({ height: "24px" })) },
          content
        )
      ),
      _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_Button2.default, {
          small: true,
          mode: "secondary",
          label: label,
          onClick: onSelect,
          className: _helpersStylesIcons.buttonStylesPrimary
        })
      )
    ),
    error && _react2.default.createElement(OptionCardErrorOverlay, { title: error.title, description: error.description })
  );
}

function EpicWalletOptionCard(_ref3) {
  var eligibilityData = _ref3.eligibilityData,
      dialogs = _ref3.dialogs;
  var epicWallet = eligibilityData.epicWallet;
  var isEligible = epicWallet.isEligible,
      amountToRefundInUserCurrency = epicWallet.amountToRefundInUserCurrency,
      amountToRefundWithBonusInUserCurrency = epicWallet.amountToRefundWithBonusInUserCurrency,
      isUserCountryWalletInActive = epicWallet.isUserCountryWalletInActive,
      userCurrency = epicWallet.userCurrency;

  var error = void 0;

  // Epic Wallet is not activated yet.
  if (isUserCountryWalletInActive) {
    error = {
      title: "This option is not available due to limitations on your Epic Wallet.",
      description: _react2.default.createElement(
        "div",
        { className: (0, _helpersStylesIcons.boxStyles)({ height: "100%" }) },
        "For more information, please reach out to",
        " ",
        _react2.default.createElement(
          "a",
          { href: _config2.default.forumBaseUrl, className: _helpersStylesIcons.anchorStyles, target: "_blank" },
          "our support team"
        ),
        "."
      )
    };
  }

  // Epic Wallet balance is already at maximum ($2000 currently).
  if (!isUserCountryWalletInActive && !isEligible) {
    error = {
      title: "Epic Wallet option is unavailable",
      description: _react2.default.createElement(
        "div",
        { className: (0, _helpersStylesIcons.boxStyles)({ height: "100%" }) },
        "Points conversion would result in your Epic Wallet balance being higher than the maximum allowed. Instead, you may receive a cash refund at the same exchange rate as you would get if you were to convert to Epic Wallet credit."
      )
    };
  }

  return _react2.default.createElement(OptionCard, {
    title: _react2.default.createElement(
      "div",
      { className: (0, _helpersStylesIcons.boxStyles)({ display: "flex", gap: "8px", alignItems: "center" }) },
      _react2.default.createElement(
        "span",
        { className: (0, _helpersStylesIcons.boxStyles)({ marginBottom: "-3px" }) },
        _react2.default.createElement(_helpersStylesIcons.OptionIconSvg, null)
      ),
      _react2.default.createElement(
        "span",
        null,
        "Convert to Epic Wallet Credits"
      )
    ),
    content: _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "p",
        null,
        "By converting your points to",
        " ",
        _react2.default.createElement(
          "a",
          {
            href: "https://www.epicgames.com/help/en-US/c-Category_BillingSupport/c-EpicGamesStore/how-can-i-use-the-epic-wallet-a000084856",
            className: _helpersStylesIcons.anchorStyles,
            target: "_blank" },
          "Epic Wallet credit"
        ),
        ", you will receive",
        " ",
        _react2.default.createElement(
          "span",
          { className: (0, _helpersStylesIcons.textStyles)({ color: "#A9D34F" }) },
          "30% more value"
        ),
        "."
      ),
      _react2.default.createElement("br", null),
      _react2.default.createElement(
        "p",
        null,
        "Click the button below to start your request for a",
        " ",
        _react2.default.createElement(
          "del",
          null,
          formatCurrency(amountToRefundInUserCurrency, userCurrency)
        ),
        " ",
        _react2.default.createElement(
          "span",
          { className: (0, _helpersStylesIcons.textStyles)({ weight: "600", color: "white" }) },
          formatCurrency(amountToRefundWithBonusInUserCurrency, userCurrency)
        ),
        " ",
        "Epic Wallet credit."
      ),
      _react2.default.createElement("br", null),
      _react2.default.createElement(
        "p",
        null,
        "You will need to accept Epic Wallet Terms and Conditions."
      )
    ),
    onSelect: function onSelect() {
      return dialogs.custom(_react2.default.createElement(_EpicWalletTermsPopup2.default, null));
    },
    error: error
  });
}

function HyperWalletOptionCard(_ref4) {
  var dialogs = _ref4.dialogs,
      eligibilityData = _ref4.eligibilityData;
  var hyperWallet = eligibilityData.hyperWallet;
  var isEligible = hyperWallet.isEligible,
      amountToRefundIncludingTax = hyperWallet.amountToRefundIncludingTax,
      isBonusApplied = hyperWallet.isBonusApplied,
      amountToRefundWithBonusIncludingTax = hyperWallet.amountToRefundWithBonusIncludingTax;

  var error = void 0;

  // HyperWallet not supported in user's country/location.
  if (!isEligible) {
    error = {
      title: "Hyperwallet does not support your location.",
      description: null
    };
  }

  return _react2.default.createElement(OptionCard, {
    title: _react2.default.createElement(
      "div",
      null,
      "Get a cash refund"
    ),
    content: _react2.default.createElement(
      "div",
      null,
      isBonusApplied ? _react2.default.createElement(
        "p",
        null,
        "Click the button to request for",
        " ",
        _react2.default.createElement(
          "del",
          null,
          formatCurrency(amountToRefundIncludingTax, "USD")
        ),
        " ",
        _react2.default.createElement(
          "span",
          { className: (0, _helpersStylesIcons.textStyles)({ weight: "600", color: "white" }) },
          formatCurrency(amountToRefundWithBonusIncludingTax, "USD")
        ),
        " ",
        "refund to your bank account."
      ) : _react2.default.createElement(
        "p",
        null,
        "Click the button to request for",
        " ",
        _react2.default.createElement(
          "span",
          { className: (0, _helpersStylesIcons.textStyles)({ weight: "600", color: "white" }) },
          formatCurrency(amountToRefundIncludingTax, "USD")
        ),
        " ",
        "refund to your bank account."
      ),
      _react2.default.createElement("br", null),
      _react2.default.createElement(
        "p",
        null,
        "We will send your name, birthdate and contact details to Hyperwallet. They will email you about next steps. Learn how HyperWallet handles your information",
        " ",
        _react2.default.createElement(
          "a",
          {
            className: _helpersStylesIcons.anchorStyles,
            target: "_blank",
            href: "https://docs.hyperwallet.com/content/payee-requirements/v1/payee-verification/individual-payee" },
          "here"
        ),
        "."
      )
    ),
    onSelect: function onSelect() {
      return dialogs.custom(_react2.default.createElement(_HyperWalletFormPopup2.default, null), {
        preventCloseOnOutsideClick: true,
        preventCloseOnEscape: true
      });
    },
    error: error
  });
}

exports.default = OptionCard;


//////////////////
// WEBPACK FOOTER
// ./src/pages/ConvertPoints/RefundOptionCards.jsx
// module id = 2909
// module chunks = 0